import { lazy } from "react";
import Loadable from "components/Loadable.tsx";
import Form from "./components/Form";
import CirculationSettingsTab from "./components/CirculationSettingsTab";
import FineSettingsTab from "./components/FineSettingsTab";
import HolidaySettingsTab from "./components/HolidaySettingsTab";
import EmailSettingsTab from "./components/EmailSettingsTab";
import ReminderSettingsTab from "./components/ReminderSettingsTab";

const LibraryList = Loadable(
  lazy(() => import("features/library/components/List"))
);
const LibraryPage = Loadable(
  lazy(() => import("features/library/components/Page"))
);
const GeneralSettingsTab = Loadable(
  lazy(() => import("features/library/components/GeneralSettingsTab"))
);
const MemberCardSettingsTab = Loadable(
  lazy(() => import("features/library/components/MemberCardSettingsTab"))
);

const routes = {
  path: "library",
  children: [
    { path: "", element: <LibraryList /> },
    { path: "add", element: <GeneralSettingsTab /> },
    { path: "edit/:libraryID?", element: <LibraryPage /> },
    {
      path: "edit/:libraryID?/general",
      element: <Form />,
      children: [{ path: "", element: <GeneralSettingsTab /> }],
    },
    {
      path: "edit/:libraryID",
      element: <Form />,
      children: [{ path: "", element: <GeneralSettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/circulation",
      element: <Form />,
      children: [{ path: "", element: <CirculationSettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/fine",
      element: <Form />,
      children: [{ path: "", element: <FineSettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/holiday",
      element: <Form />,
      children: [{ path: "", element: <HolidaySettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/email",
      element: <Form />,
      children: [{ path: "", element: <EmailSettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/reminder",
      element: <Form />,
      children: [{ path: "", element: <ReminderSettingsTab /> }],
    },
    {
      path: "edit/:libraryID?/membercard",
      element: <Form />,
      children: [{ path: "", element: <MemberCardSettingsTab /> }],
    },
  ],
};

export default routes;
